// extracted by mini-css-extract-plugin
export default {"root":"style_root__rnrr8","title":"style_title__lfoEu"};